import { render, staticRenderFns } from "./myDonateList.vue?vue&type=template&id=daf0d954&scoped=true&"
import script from "./myDonateList.vue?vue&type=script&lang=js&"
export * from "./myDonateList.vue?vue&type=script&lang=js&"
import style0 from "./myDonateList.vue?vue&type=style&index=0&id=daf0d954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf0d954",
  null
  
)

export default component.exports